import axios from '@/libs/api.request'

export const getSensitiveFieldList = (page, limit, key) => {
  return axios.request({
    url: '/v1/system/security-sensitive-field/',
    method: 'get',
    params: {
      page,
      limit,
      key: key
    }
  })
}

export const operationSensitiveField = (data, meth) => {
  return axios.request({
    url: '/v1/system/security-sensitive-field/',
    method: meth,
    data
  })
}